<template>
  <v-card>
    <v-card-title>
      <b>Services</b>
      <v-spacer></v-spacer>
      <v-btn
        small
        icon
        v-if="!creating"
        class="float-sm-right mt-2 mx-2"
        @click="$emit('createReq')"
      >
        <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-list>
        <Alert v-if="showAlert" text="Service updated" type="success" />
        <v-list-item
          v-for="(service, index) in servicesData"
          :key="service.id"
          class="card-shadow border-radius-xl"
        >
          <v-list-item-content>
            <v-row>
              <v-col cols="4">
                <EditableField
                  :value="service.name"
                  :keyPath="`servicesData.${index}.name`"
                  hideLabel
                  label="Name"
                  :editing="editing[index]"
                  @save="updateApiData"
                >
                  <template #value>
                    <v-list-item-title class="mb-0"
                      ><span class="font-weight-bold">{{
                        service.name
                      }}</span></v-list-item-title
                    >
                  </template>
                </EditableField>
                <EditableField
                  :value="service.url"
                  :keyPath="`servicesData.${index}.url`"
                  label="URL"
                  hideLabel
                  :editing="editing[index]"
                  @save="updateApiData"
                >
                  <template #value>
                    <v-list-item-subtitle class="mb-2"
                      ><i
                        ><a :href="'https://' + service.url" target="_blank">{{
                          service.url
                        }}</a></i
                      ></v-list-item-subtitle
                    >
                  </template>
                </EditableField>
              </v-col>
              <v-col cols="4"> </v-col>
              <v-col cols="4">
                <v-btn
                  icon
                  small
                  v-if="!editing[index]"
                  @click="deleteService(index)"
                  class="float-sm-right mt-2 mx-2"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  class="float-sm-right mt-2 mx-2"
                  @click="toggleEdit(index)"
                >
                  <v-icon>{{
                    editing[index] ? 'mdi-content-save' : 'mdi-account-edit'
                  }}</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  v-if="editing[index]"
                  @click="cancelEdit(index)"
                  class="btn-sm float-sm-right mt-2 mx-2"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
  import Alert from '@/components/Alert.vue'
  import EditableField from '../../components/EditableField.vue'
  import { setNestedValue } from '@/util/helpers.js'

  export default {
    name: 'ClientServices',
    components: { EditableField, Alert },
    props: {
      services: {
        type: Array,
        default: () => [],
        required: true,
      },
      creating: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        editing: [],
        servicesData: this.services,
        showAlert: false,
      }
    },
    methods: {
      toggleEdit(index) {
        if (this.editing[index]) {
          this.updateService(index)
        }
        this.$set(this.editing, index, !this.editing[index])
      },
      updateApiData(details) {
        setNestedValue(this, details.keyPath, details.value)
      },
      updateService(index) {
        setTimeout(() => {
          console.log(this.servicesData)
          let details = { ...this.servicesData[index] }
          let serviceId = details['id']
          for (let key of [
            'created_at',
            'updated_at',
            'deleted_at',
            'client_id',
            'id',
          ])
            delete details[key]
          this.apiModifyClientService(serviceId, details)
            .then(response => {
              this.servicesData[index] = response
              this.showAlert = true
            })
            .catch(error => {
              console.log(error)
            })
        }, 200)
      },
      cancelEdit(index) {
        this.servicesData[index] = { ...this.services[index] }
        this.$set(this.editing, index, false)
      },
      deleteService(index) {
        let serviceId = this.servicesData[index].id
        this.apiDeleteClientService(serviceId)
          .then(() => {
            this.servicesData.splice(index, 1)
            this.editing.splice(index, 1)
            this.showAlert = true
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
    watch: {
      services: {
        handler(newServices) {
          this.editing = newServices.map(() => false)
          this.servicesData = newServices
        },
        immediate: true,
      },
    },
  }
</script>
